// extracted by mini-css-extract-plugin
export default {"switchBox":"BidNowDataForm_switchBox__VR2n-","switchText":"BidNowDataForm_switchText__BHvuI","switchGray":"BidNowDataForm_switchGray__DI-oN"};